import script from "./AppPremiumLoader.vue?vue&type=script&setup=true&lang=js"
export * from "./AppPremiumLoader.vue?vue&type=script&setup=true&lang=js"

import "./AppPremiumLoader.vue?vue&type=style&index=0&id=0b906f0d&lang=css"

const __exports__ = script;

export default __exports__